import React from 'react';
import DraggableListCard from './DraggableListCard';

/**
 * Pinned lists section in MyLists
 * Uses move up/down buttons for reordering instead of drag-and-drop
 */
function PinnedDropZone({
  pinnedLists,
  isCompactView,
  isReorderMode,
  onDrop,
  onListClick,
  maxPinnedLists,
}) {
  const handleMoveUp = (e, list, index) => {
    e.stopPropagation();
    if (index > 0) {
      // Move within pinned: reorder to index - 1
      onDrop(list.id, 'pinned', 'pinned', index - 1);
    }
  };

  const handleMoveDown = (e, list, index) => {
    e.stopPropagation();
    if (index < pinnedLists.length - 1) {
      // Move within pinned: reorder to index + 1
      onDrop(list.id, 'pinned', 'pinned', index + 1);
    }
  };

  const handleUnpin = (e, list) => {
    e.stopPropagation();
    // Move from pinned to unpinned at position 0
    onDrop(list.id, 'pinned', 'unpinned', 0);
  };

  // Only render if there are pinned lists
  if (pinnedLists.length === 0) {
    return null;
  }

  return (
    <div className="pinned-section">
      <div className={`pinned-drop-zone ${isCompactView ? 'compact-view' : ''}`}>
        {pinnedLists.map((list, index) => (
          <div key={list.id} className="list-item-wrapper">
            {/* Reorder controls */}
            {isReorderMode && (
              <div className="list-reorder-controls">
                <button
                  className="reorder-btn reorder-btn-up"
                  onClick={(e) => handleMoveUp(e, list, index)}
                  disabled={index === 0}
                  aria-label="Move list up"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                    <polyline points="18 15 12 9 6 15" />
                  </svg>
                </button>
                <button
                  className="reorder-btn reorder-btn-down"
                  onClick={(e) => handleMoveDown(e, list, index)}
                  disabled={index === pinnedLists.length - 1}
                  aria-label="Move list down"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>
                <button
                  className="reorder-btn reorder-btn-unpin"
                  onClick={(e) => handleUnpin(e, list)}
                  aria-label="Unpin list"
                  title="Unpin"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                    <line x1="18" y1="6" x2="6" y2="18"/>
                    <line x1="6" y1="6" x2="18" y2="18"/>
                  </svg>
                </button>
              </div>
            )}
            <DraggableListCard
              list={list}
              isCompactView={isCompactView}
              isReorderMode={isReorderMode}
              onClick={onListClick}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default PinnedDropZone;
